<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ScheduleBase from '../../../../../schedule/components/ScheduleBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        useFullContainer: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <ScheduleBase />
</template>